module.exports = __webpack_public_path__ + "static/media/nodeguard_big.04708eeb.svg";